<ng-container *transloco="let t">

    <!-- EVENTS CARD -->
    <app-admin-card-with-title
            [cardTitle]="t('league.details.events')" [showToggleButton]="true"
            [isContentVisible]="!eventsCollapsed" [removeTopMargin]="true">
        <div slot="trailingWidget">
            <div class="d-flex">
                <div class="pe-4">
                    <app-rounded-button [label]="t('league.details.select.events')"
                                        [btnClass]="'rounded-button--solid'"
                                        (onClick)="openEventsForLeagueList()">
                        <i class="bi bi-plus-circle pe-2"></i>
                    </app-rounded-button>
                </div>
            </div>
        </div>
        <app-league-events-table [events]="leagueEvents?.events ?? []"
                                 [languages]="languages"
                                 [league]="league"
                                 [disableEditing]="disableEditing"
                                 (onChangeEventType)="openChangeTypeDialog($event, false)"
                                 (onRemove)="openDeleteDialog($event, false)"
                                 (onOpenShortName)="openShortNameModal($event)"/>

    </app-admin-card-with-title>

    <!-- TEMPLATE EVENTS CARD -->
    <div class="mt-4">
        <app-admin-card-with-title
                [cardTitle]="t('league.details.events.templates')" [showToggleButton]="true"
                [isContentVisible]="!templateCollapsed" [removeTopMargin]="true">
            <div slot="trailingWidget">
                <div class="d-flex">
                    <div class="pe-4">
                        <app-rounded-button [label]="t('league.events.create.template')"
                                            (onClick)="openCreateEventTemplate()">
                            <i class="bi bi-plus-square-dotted pe-2"></i>
                        </app-rounded-button>
                    </div>
                </div>
            </div>
            <app-league-events-table [events]="leagueEvents?.templateEvents ?? []"
                                     [league]="league"
                                     [languages]="languages" [disableEditing]="disableEditing"
                                     [type]="LeagueEventTableType.TEMPLATE"
                                     (onChangeEventType)="openChangeTypeDialog($event, true)"
                                     (onOpenDetails)="openCreateEventTemplate($event)"
                                     (onRemove)="openDeleteDialog($event, true)"/>
        </app-admin-card-with-title>
    </div>

    <!-- PENDING EVENTS CARD -->
    <div class="mt-4">
        <app-admin-card-with-title
                [cardTitle]="t('league.details.events.pending')" [showToggleButton]="true"
                [isContentVisible]="!pendingCollapsed" [removeTopMargin]="true">
            <app-league-events-table [events]="leagueEvents?.pendingEvents ?? []"
                                     [league]="league"
                                     [languages]="languages" [disableEditing]="disableEditing"
                                     [type]="LeagueEventTableType.PENDING"
                                     (onRemove)="openDeleteDialog($event, false)"/>
        </app-admin-card-with-title>
    </div>


</ng-container>
